import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import Endpoints from "../../../api/endpoints";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { Card, Typography, Descriptions, Tag } from "antd";
import { IoNotifications, IoPerson, IoTime } from "react-icons/io5";

const { Title } = Typography;

const UserNotificationDetails = () => {
  const { userNotificationId } = useParams();
  const [notificationData, setNotificationData] = useState(null);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const fetchUserNotificationDetails = async () => {
      const result = await EndpointFunctions.fetchData({
        endpointURL: Endpoints.getUserNotification,
        axiosPrivate: axiosPrivate,
        httpParams: { id: userNotificationId },
      });
      if (result.success) {
        setNotificationData(result.data);
      }
    };
    fetchUserNotificationDetails();
  }, [userNotificationId, axiosPrivate]);

  if (!notificationData) {
    return <div>Yükleniyor...</div>;
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div style={{ padding: "24px" }}>
      <Card>
        <Title level={4} style={{ marginBottom: "24px" }}>
          <IoNotifications style={{ marginRight: "8px" }} />
          Bildirim Detayları
        </Title>

        <Descriptions bordered column={1}>
          <Descriptions.Item label="Başlık">
            {notificationData.notification.title}
          </Descriptions.Item>
          <Descriptions.Item label="Mesaj">
            {notificationData.notification.body}
          </Descriptions.Item>
          {notificationData.notification.imageUrl && (
            <Descriptions.Item label="Görsel">
              <img
                src={notificationData.notification.imageUrl}
                alt="Bildirim"
                style={{ maxWidth: "200px" }}
              />
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Kullanıcı Rolü">
            <Tag color="blue">
              <IoPerson style={{ marginRight: "4px" }} />
              {notificationData.user.role}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Uygulama">
            <Tag color="green">{notificationData.notification.app}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Alınma Tarihi">
            <IoTime style={{ marginRight: "4px" }} />
            {formatDate(notificationData.receivedAt)}
          </Descriptions.Item>
          {notificationData.notification.topic && (
            <Descriptions.Item label="Konu">
              {notificationData.notification.topic}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
    </div>
  );
};

export default UserNotificationDetails;
